import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { colors, fonts } from "../theme";
import { View, Text, Card, Button, Press, ScreenHeader, Loading } from "../ui";
import { Icon } from "../Icon";
import { useI18n } from "../i18n";
import { apiListUsers, apiCreateUser, apiDeleteUser } from "../api";

export default function AdminUsers() {
  const navigate = useNavigate();
  const { tr } = useI18n();
  const [users, setUsers] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("learner");
  const [error, setError] = useState("");
  const [creating, setCreating] = useState(false);

  const load = () => apiListUsers().then(setUsers).catch(() => setUsers([]));
  useEffect(() => { load(); }, []);

  const create = async () => {
    setCreating(true); setError("");
    try {
      await apiCreateUser({ name: name.trim(), email: email.trim().toLowerCase(), password, role });
      setName(""); setEmail(""); setPassword("");
      load();
    } catch (e) { setError(e?.message || "Error"); }
    finally { setCreating(false); }
  };
  const del = async (id) => { await apiDeleteUser(id); load(); };

  const input = { backgroundColor: colors.surfaceSecondary, border: `1px solid ${colors.border}`, borderRadius: 14, padding: "0 16px", height: 52, fontWeight: fonts.medium, fontSize: 15, color: colors.onSurface, marginBottom: 12, width: "100%" };

  return (
    <View style={{ flex: 1, minHeight: "100vh", backgroundColor: colors.surfaceSecondary }}>
      <ScreenHeader title={tr("users")} onBack={() => navigate(-1)} />
      <View style={{ padding: 20 }}>
        <Card style={{ marginBottom: 20 }}>
          <Text style={{ fontWeight: fonts.bold, fontSize: 16, color: colors.onSurface, marginBottom: 12 }}>{tr("createUser")}</Text>
          <input data-testid="au-name" value={name} onChange={(e) => setName(e.target.value)} placeholder={tr("name")} style={input} />
          <input data-testid="au-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder={tr("email")} style={input} />
          <input data-testid="au-password" value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder={tr("password")} style={input} />
          <View row style={{ gap: 10, marginBottom: 14 }}>
            {["learner", "admin"].map((r) => (
              <Press key={r} testID={`au-role-${r}`} onClick={() => setRole(r)} style={{
                flex: 1, height: 46, borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center",
                backgroundColor: role === r ? colors.brandPrimary : colors.surfaceSecondary, border: `1px solid ${role === r ? colors.brandPrimary : colors.border}`,
              }}>
                <Text style={{ fontWeight: fonts.semibold, fontSize: 14, color: role === r ? colors.onBrandPrimary : colors.muted }}>{r === "learner" ? tr("learner") : tr("admin")}</Text>
              </Press>
            ))}
          </View>
          {error ? <Text style={{ fontWeight: fonts.medium, fontSize: 13, color: colors.error, marginBottom: 10 }}>{error}</Text> : null}
          <Button testID="au-create" title={tr("createUser")} loading={creating} disabled={!name || !email || password.length < 4} onPress={create} icon="plus" />
        </Card>

        {users === null ? <Loading /> : users.map((u) => (
          <Card key={u.id} style={{ flexDirection: "row", alignItems: "center", gap: 12, marginBottom: 10 }}>
            <View style={{ width: 40, height: 40, borderRadius: 20, backgroundColor: u.role === "admin" ? colors.warningSurface : colors.brandTertiary, alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Icon name={u.role === "admin" ? "shield" : "user"} size={20} color={u.role === "admin" ? colors.warning : colors.brandPrimary} weight="fill" />
            </View>
            <View style={{ flex: 1, minWidth: 0 }}>
              <Text style={{ fontWeight: fonts.semibold, fontSize: 15, color: colors.onSurface }}>{u.name}</Text>
              <Text style={{ fontWeight: fonts.regular, fontSize: 12, color: colors.muted }}>{u.email} · {u.role}</Text>
            </View>
            <Press testID={`au-del-${u.id}`} onClick={() => del(u.id)}><Icon name="trash" size={18} color={colors.error} /></Press>
          </Card>
        ))}
      </View>
    </View>
  );
}
